module.exports = __webpack_public_path__ + "static/company_logo02-74e1f3a826f64653703417899ba0ded1.png";